var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_c('button',{staticClass:"bookmark"},[_c('img',{attrs:{"src":_vm.src,"width":"16"}}),_vm._v(_vm._s(_vm.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }